import { render, staticRenderFns } from "./Course2.vue?vue&type=template&id=42febf7e&scoped=true&"
import script from "./Course2.vue?vue&type=script&lang=js&"
export * from "./Course2.vue?vue&type=script&lang=js&"
import style0 from "./Course2.vue?vue&type=style&index=0&id=42febf7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42febf7e",
  null
  
)

export default component.exports